import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { StatementStatusEnum } from '../models/StatementStatusEnum';
import { useStores } from '../stores/Hooks';

interface INavButtons
{
	/** Текущая закладка */
	CurrentPage: number,
}


export const NavButtons: React.FC<INavButtons> = observer(
	(
		// входные параметры компонента
		{ CurrentPage }: INavButtons
	) =>
{
		const { uiState } = useStores();

		// #region PreviousButton
		function PreviousButtonDisabled(): boolean
		{
			return false;
		}

		function PreviousButtonVisible(): boolean
		{
			if (CurrentPage < 2) return false;

			return true;
		}

		function PreviousButtonText(): string
		{
			return "Назад";
		}
		// #endregion

		// #region NextButton
		function NextButtonDisabled(): boolean
		{
			if (CurrentPage === 2)
			{
				return !uiState.info.AgreementCheck.Value;
			}

			if (CurrentPage === 4)
			{
				return !uiState.register.IsValid || !uiState.info.IsValid || !uiState.files.IsValid;
			}

			return false;
		}

		function NextButtonVisible(): boolean
		{
			if (CurrentPage === 1 && !uiState.register.FeedbackEmail.IsConfirmed) return false;
			if (CurrentPage === 4)
			{
				switch (uiState.StatementStatus)
				{
					case StatementStatusEnum.NotCreated:
					case StatementStatusEnum.Created:
					case StatementStatusEnum.Signed: return true;
					default: return false;
				}
			}

			return true;
		}

		function NextButtonText(): any
		{
			if (CurrentPage === 0) return "Продолжить";
			if (CurrentPage === 4)
			{
				switch (uiState.StatementStatus)
				{
					case StatementStatusEnum.NotCreated: return (<>Сформировать <span className="d-none d-sm-inline">заявление</span></>);
					case StatementStatusEnum.Created: return "Подписать";
					case StatementStatusEnum.Signed: return "Отправить";
				}
			}
			return "Вперёд";
		}
		// #endregion

		return (
			<>
				{((PreviousButtonVisible() || NextButtonVisible()) && !uiState.IsLoading) &&
					<div className="action-block">
						<div className="row no-gutters">
							<div className="col-lg-9">
								<div className="controls d-flex align-items-center">
									{PreviousButtonVisible() &&
										<button
											className="btn mr-2"
											disabled={PreviousButtonDisabled()}
											onClick={() => uiState.PreviousButtonClick(CurrentPage)}
										>{PreviousButtonText()}</button>
									}
									{NextButtonVisible() &&
										<button
											className="btn btn-primary"
											disabled={NextButtonDisabled()}
											onClick={() => uiState.NextButtonClick(CurrentPage)}
										>{NextButtonText()}</button>
									}
								</div>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
)
